@if (cardInfo()) {
  <mat-card>
    @if (!isCampaignSMS()) {
      <mat-card-header [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
        @if (showAvatar) {
          <div matCardAvatar>
            <glxy-avatar
              [width]="AVATAR_WIDTH"
              [icon]="isPhoneCall() ? 'call' : 'question_answer'"
              backgroundColor="var(--primary-background-color)"
              textColor="#9E9E9E"
            ></glxy-avatar>
          </div>
        }
        <mat-card-title>
          @if (cardInfo().body) {
            <div class="title">
              <div [innerHtml]="cardInfo().body | sanitizeHtml"></div>
            </div>
          }
          @if (cardInfo().activityUrl) {
            <div>
              <a [href]="cardInfo().activityUrl">{{ cardInfo().activityUrlName || cardInfo().activityUrl }}</a>
            </div>
          }
        </mat-card-title>
        <mat-card-subtitle>
          @if (cardInfo().effectiveDate) {
            <p class="effective-date">
              {{ cardInfo().effectiveDate | date: dateFormat }}
            </p>
          }
        </mat-card-subtitle>
      </mat-card-header>
    } @else {
      <mat-card-header [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
        @if (showAvatar) {
          <div matCardAvatar>
            <glxy-avatar
              [width]="AVATAR_WIDTH"
              icon="campaign"
              backgroundColor="var(--primary-background-color)"
              textColor="#9E9E9E"
            ></glxy-avatar>
          </div>
        }
        @if (headerText()) {
          <mat-card-title class="mat-card-title">
            <span class="title">{{ headerText() }}</span>
          </mat-card-title>
        } @else {
          <mat-card-title>
            <span class="title">{{ 'ACTIVITY.UNKNOWN_TITLE' | translate }}</span>
          </mat-card-title>
        }
        @if (cardInfo().effectiveDate) {
          <mat-card-subtitle>
            <p class="effective-date">
              {{ cardInfo().effectiveDate | date: dateFormat }}
            </p>
          </mat-card-subtitle>
        }
      </mat-card-header>

      <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 16).toString() + 'px'">
        <span class="campaign-display">
          @if (cardInfo().activityName) {
            <strong>
              <span>{{ cardInfo().activityName }}</span>
            </strong>
          }
          {{ 'CONTACT.ACTIVITIES.CREATED_FROM' | translate }}
          @if (cardInfo().sourceName) {
            <strong>
              <span class="campaign-display">
                <a href="{{ cardInfo()?.activityUrl }}" target="_blank">{{ cardInfo().sourceName }}</a>
              </span>
            </strong>
          }
        </span>
      </mat-card-content>
    }
  </mat-card>
}
